import React from 'react';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ButtonBase from '@mui/material/ButtonBase';

import LayerIcon from 'ff/debrief/components/customIcons/LayerIcon';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import styled from 'styled-components';
import MapSettings from 'ff/debrief/components/map/settings/MapSettings';
import { LayerSettings } from 'ff/debrief/components/map/settings/LayerSettings';

interface Props {}

type SettingsPanelType = 'layers' | 'settings';

const LayerSelector: React.FC<Props> = props => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [settingsPanel, setSettingsPanel] = React.useState<SettingsPanelType>(
        'layers'
    );
    const anchorElRef = React.useRef(null);

    let settingsJsx = null;
    if (settingsPanel == 'layers') {
        settingsJsx = <LayerSettings closeHandler={() => setIsOpen(false)} />;
    } else if (settingsPanel === 'settings') {
        settingsJsx = <MapSettings />;
    }

    return (
        <>
            <ButtonBase
                ref={anchorElRef}
                onClick={() => setIsOpen(!isOpen)}
                sx={{
                    height: '32px',
                    width: '32px',
                    minWidth: '0px',
                    borderRadius: '4px',
                    backgroundColor: '#FFFFFF',
                    boxShadow:
                        '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
                }}
            >
                <LayerIcon
                    sx={{ height: '17px', width: '17px', color: '#000000' }}
                />
            </ButtonBase>
            <Menu
                anchorEl={anchorElRef?.current}
                open={isOpen}
                onClose={() => setIsOpen(false)}
                sx={{
                    marginTop: '4px',
                    '& .MuiMenu-list': {
                        padding: '0',
                        minWidth: '200px',
                    },
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {(window as any).currentUser && (
                    <SettingsToggle
                        settingsPanel={settingsPanel}
                        setSettingsPanel={setSettingsPanel}
                    />
                )}
                {settingsJsx}
            </Menu>
        </>
    );
};

interface ToggleProps {
    settingsPanel: SettingsPanelType;
    setSettingsPanel: (panel: SettingsPanelType) => void;
}

const CustomToggleButton = styled(ToggleButton)`
    padding: 8px 16px;
    border: none;
    border-bottom: 1px solid #e5e5e5;
    border-radius: 0;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    &.Mui-selected {
        border-bottom: 3px solid #3498db;
    }
`;

export const SettingsToggle: React.FC<ToggleProps> = props => {
    const { settingsPanel, setSettingsPanel } = props;
    return (
        <MenuItem sx={{ padding: '0' }}>
            <ToggleButtonGroup
                color="primary"
                value={settingsPanel}
                exclusive
                onChange={(e, newValue) => {
                    if (newValue !== null) {
                        setSettingsPanel(newValue);
                    }
                }}
            >
                <CustomToggleButton
                    value="layers"
                    sx={{
                        padding: '2px 11px',
                    }}
                >
                    Charts & Layers
                </CustomToggleButton>
                <CustomToggleButton
                    value="settings"
                    sx={{
                        padding: '2px 11px',
                    }}
                >
                    Map Settings
                </CustomToggleButton>
            </ToggleButtonGroup>
        </MenuItem>
    );
};

export default LayerSelector;
